/**
 * Created by anthony on 7/3/14.
 */
var historyDataModel = angular.module('historyDataModel', ['familyModel']);
historyDataModel.factory('HistoryDataModelFactory', function(FamilyModelFactory, authServiceFactory){
    var HistoryDataModel = function(){
        this.endpoint = "/historyData";
    }
    HistoryDataModel.prototype = new FamilyModelFactory();
    HistoryDataModel.prototype.parent = FamilyModelFactory.prototype;
    
    return HistoryDataModel;
});

historyDataModel.service('HistoryDataModelService', function(HistoryDataModelFactory){
    var historyDataModel = new HistoryDataModelFactory();
    return historyDataModel;
});
